import { updates } from '../api/util'
import merge from 'deepmerge'

const ACTION_LOADING = 'UPDATES/LOADING',
    ACTION_DATA = 'UPDATES/DATA'

const initState = {
    init: false,
    loading: false,
    data: {}
}

export default function (state = initState, { type, payload }) {
    switch (type) {
        case ACTION_LOADING:
            return {
                ...state,
                loading: payload
            }
        case ACTION_DATA:
            return {
                ...state,
                init: true,
                loading: false,
                data: payload
            }
        default:
            return state;
    }
}

export function update(data=null) {
    return async (dispatch, getState) => {
        if(data) {
            dispatch({
                type: ACTION_DATA,
                payload: merge(getState().updates.data, data)
            })
            return;
        }
        dispatch({
            type: ACTION_LOADING,
            payload: true
        })
        const result = await updates()
        dispatch({
            type: ACTION_DATA,
            payload: result
        })
    }
}